
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contactos",
      function () {
        return require("private-next-pages/contactos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contactos"])
      });
    }
  